import { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import type { GalleryItem } from '@/types/api'
import { cn } from '@/lib/utils'

export function GalleryMasonry({ items }: { items: GalleryItem[] }) {
  const [index, setIndex] = useState(-1)
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[180px] gap-3">
        {items.map((g, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={cn(
              'relative rounded-lg overflow-hidden group bg-pitch-800',
              g.size === 'wide' && 'md:col-span-2',
              g.size === 'tall' && 'row-span-2'
            )}
          >
            <img
              src={g.src}
              alt={g.caption}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-3 left-3 right-3 text-white font-display text-sm uppercase tracking-wider opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
              {g.caption}
            </div>
          </button>
        ))}
      </div>
      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={items.map((g) => ({ src: g.src, alt: g.caption, title: g.caption }))}
      />
    </>
  )
}
